import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

type StyledContainerProps = {
  plain?: boolean;
};

const Container = styled.span<StyledContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;

  top: 0;
  left: 0;
  bottom: 0;

  padding: 0.6rem 1.2rem;
  width: 5rem;

  border-top-left-radius: ${({ theme }) => theme.borderRadius.base};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.base};

  ${({ plain }) =>
    plain
      ? css`
          border: none;
          background-color: transparent;
        `
      : css`
          border: 0.2rem solid ${pickColor('borderColorLight')};
          background-color: ${pickColor('blueLight')};
        `}

  box-sizing: border-box;
`;

export { Container };
